module.exports = __webpack_public_path__ + "img/warning-icon.26018439.svg";